module.exports = __webpack_public_path__ + "static/media/logo-gramado.8ef67821.png";